import { memo } from 'react';

/**
 * ズームコントロールコンポーネント
 * 拡大・縮小ボタンとズームレベル表示
 * ※ memo化により、propsが変更されない限り再レンダリングを防止
 */
const ZoomControls = memo(({ zoomLevel, onZoomIn, onZoomOut }) => {
  return (
    <div className="pdf-control-group zoom-group">
      {/* ズームインボタン */}
      <button
        className="pdf-control-button"
        onClick={onZoomIn}
        title="拡大"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          <line x1="11" y1="8" x2="11" y2="14"></line>
          <line x1="8" y1="11" x2="14" y2="11"></line>
        </svg>
      </button>
      
      {/* ズームアウトボタン */}
      <button
        className="pdf-control-button"
        onClick={onZoomOut}
        title="縮小"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          <line x1="8" y1="11" x2="14" y2="11"></line>
        </svg>
      </button>

      {/* ズームレベル表示 */}
      <span className="zoom-level">{zoomLevel}%</span>
    </div>
  );
});

export default ZoomControls;
